// @newgenus/fire-compat — see ../README.md.
export * from './app';
